import { CareCoordinatorReferral, Referral } from 'types';
import { UnifiedReferralModel } from '../models/UnifiedReferralModel';
import { CareCoordinatorReferralAdapter, type AdapterContext as CareCoordinatorContext } from '../adapters/CareCoordinatorReferralAdapter';
import { CaseManagementReferralAdapter, type AdapterContext as CaseManagementContext } from '../adapters/CaseManagementReferralAdapter';

export class ReferralFactory {
    static fromCaseManagement(
        referral: Referral, 
        context: CaseManagementContext
    ): UnifiedReferralModel {
        return CaseManagementReferralAdapter.adapt(referral, context);
    }

    static fromCareCoordinator(
        referral: CareCoordinatorReferral,
        context: CareCoordinatorContext
    ): UnifiedReferralModel {
        return CareCoordinatorReferralAdapter.adapt(referral, context);
    }
} 